var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 36,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m5.5 18 8-1.4v3.9h-8z",
  fill: "#a9713d"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.2,
  y: 20.5,
  width: 6.6,
  height: 15.5,
  fill: "#8a6238"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m11.5 16.9v-2.6",
  fill: "none",
  stroke: "#5c6870",
  strokeWidth: 1
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 13.6,
  r: 1,
  fill: "#5c6870"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "#3c4652"
}, /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 27.6,
  width: 5,
  height: 1.8,
  rx: 0.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 21.3,
  y: 20.5,
  width: 1.8,
  height: 7.6,
  rx: 0.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.9,
  y: 29.4,
  width: 1.2,
  height: 6.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 21.4,
  y: 29.4,
  width: 1.2,
  height: 6.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 27.6,
  width: 5,
  height: 1.8,
  rx: 0.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 29.3,
  y: 20.5,
  width: 1.8,
  height: 7.6,
  rx: 0.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 25.9,
  y: 29.4,
  width: 1.2,
  height: 6.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 29.4,
  y: 29.4,
  width: 1.2,
  height: 6.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 27.6,
  width: 5,
  height: 1.8,
  rx: 0.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.3,
  y: 20.5,
  width: 1.8,
  height: 7.6,
  rx: 0.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.9,
  y: 29.4,
  width: 1.2,
  height: 6.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.4,
  y: 29.4,
  width: 1.2,
  height: 6.6
}));

function SvgTownhallRoomSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTownhallRoomSetup);
export default __webpack_public_path__ + "static/media/townhall-room-setup.347b48cc60598173f4b3932fb14b70d2.svg";
export { ForwardRef as ReactComponent };